import { useEffect } from 'react'
import PreviewModule from '../../modules/preview/Module'

import { SurveyMode } from '../../actions/types'
import { ISessionUseSyncPreviewOptions } from '../types'

const useSyncPreviewOptions: ISessionUseSyncPreviewOptions = surveyMode => {
  useEffect(() => {
    const suppressLogic = SurveyMode.XRAYS === surveyMode
    if (PreviewModule.previewOptions.suppressLogic !== suppressLogic) {
      PreviewModule.updatePreviewOptions({ suppressLogic })
    }
  }, [surveyMode])
}

export default useSyncPreviewOptions
